import { PulseLoader } from 'react-spinners';
import Button from "../Button/Button";

type Props = {
  text: string | JSX.Element,
  isDisabled?: boolean,
  fn?: (a?: any) => void,
  eventName?: string,
  isLoading?: boolean,
  actionName?: string
  notificationCount?: number,
  tone?: "default" | "brand",
};

function PrimaryButton(
  { 
    text, 
    fn = () => null, 
    isDisabled = false, 
    eventName = '', 
    isLoading = false,
    actionName,
    notificationCount,
    tone = "default",
  }: Props) {

  const track = (e: any) => {
    fn();
  }

  const enabledStyles = tone === "brand"
    ? "bg-as-pink-300 hover:bg-as-pink-500 text-white hover:text-white border-as-pink-300"
    : "bg-darker-gold-300 hover:bg-darker-gold-100 text-white hover:text-black border-gold-700";

  const buttonStyles = `
    ${isDisabled ? 'bg-gray-300 cursor-not-allowed text-white border-gray-300' : enabledStyles} 
    font-semibold 
    py-1 px-3 border rounded 
    transition ease-in-out duration-300
    w-full sm:w-auto sm:px-6 md:px-8 lg:px-10 xl:px-12
    h-8 sm:h-10 md:h-12
    text-xs sm:text-sm md:text-base
    inline-flex items-center justify-center whitespace-nowrap
  `;

  const loaderColor = tone === "brand" ? "#fda9a9" : "#fdd1d1";

  return (
    isLoading ? <PulseLoader color={loaderColor} /> : <Button 
      fn={track} 
      text={text} 
      isDisabled={isDisabled}
      cssStyles={buttonStyles}
      actionName={actionName}
      notificationCount={notificationCount}
    />
  );
}

export default PrimaryButton;
